import { Controller } from "@hotwired/stimulus";

const THRESHOLD = 3;

/**
 * 希望車リクエストバナー表示用閲覧カウント管理コントローラー
 * data-controller="car-wish-view-counter"
 *   data-car-wish-view-counter-url-value: カウントインクリメントエンドポイント
 *   data-car-wish-view-counter-banner-src-value: バナーTurbo FrameのsrcURL
 *
 * ページのURLパスをキーにしてsessionStorageで多重送信を防止する（同一タブ内で同じ車両詳細を
 * 複数回ロードしても1回のみカウント）。カウントが3に達した時点でバナーのTurbo Frameに
 * srcを設定してバナーを表示する。
 */

export default class extends Controller {
  static values = {
    url: String,
    bannerSrc: String,
  };

  connect() {
    if (!this.hasUrlValue) {
      console.error("Missing url value", this.element);
      return;
    }
    const storageKey = `car_wish_view_counted_${window.location.pathname}${window.location.search}_${this.urlValue}`;
    if (sessionStorage.getItem(storageKey)) return;

    const csrfToken = document.querySelector(
      'meta[name="csrf-token"]',
    )?.content;
    if (!csrfToken) {
      console.warn(
        "CSRF token not found, skipping car-wish-view-counter request",
      );
      return;
    }

    const bannerSrc = this.hasBannerSrcValue ? this.bannerSrcValue : null;

    sessionStorage.setItem(storageKey, "1");
    fetch(this.urlValue, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken,
      },
    })
      .then((response) => {
        if (!response.ok) {
          sessionStorage.removeItem(storageKey);
          return null;
        }
        return response.json();
      })
      .then((data) => {
        if (!data) return;
        if (data.count >= THRESHOLD) {
          this.#showBanner(bannerSrc);
        }
      })
      .catch(() => {
        sessionStorage.removeItem(storageKey);
      });
  }

  #showBanner(bannerSrc) {
    if (!bannerSrc) return;

    const setFrameSrc = (frame) => {
      if (!frame || frame.getAttribute("src")) return;
      frame.setAttribute("src", bannerSrc);
    };

    const frame = document.querySelector(
      "turbo-frame#request_car_wish_prompt_modal",
    );

    setFrameSrc(frame);
  }
}
